import { Fragment, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyToSign } from '@monorepo/client-types';
import { formatPriceWithCurrencyAndSign } from '@monorepo/hub-common';
import {
  designTokens,
  Statistic,
  TableCell,
  TableRow,
  Typography,
} from '@monorepo/nova-ui';
import { SupportedCurrencies } from '@monorepo/types';

interface InvoiceItem {
  productName: string;
  originPrice: number;
  tradingSystemFee?: number;
  currency: string;
  currencyRate: number;
  amountInCurrency: number;
}

interface Props {
  items: InvoiceItem[];
  isMobile: boolean;
}

const InvoiceTableBody: FunctionComponent<Props> = ({ items, isMobile }) => {
  const { t } = useTranslation('orders');
  return (
    <>
      {items.map((item, index) => (
        <Fragment key={`invoice-item-${index}`}>
          <TableRow>
            {!isMobile && (
              <TableCell>
                <Typography
                  variant="body2"
                  fontWeight={designTokens.typography.fontWeights.medium}
                >
                  {item.productName}
                </Typography>
              </TableCell>
            )}
            <TableCell>
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                {formatPriceWithCurrencyAndSign(
                  item.originPrice,
                  SupportedCurrencies.USD,
                )}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                {item.currency}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                {item.currencyRate.toFixed(3)}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography
                variant="body2"
                fontWeight={designTokens.typography.fontWeights.medium}
              >
                <Statistic
                  prefix={CurrencyToSign[item.currency]}
                  value={item.originPrice * item.currencyRate}
                  precision={2}
                  align="right"
                />
              </Typography>
            </TableCell>
          </TableRow>
          {!!item.tradingSystemFee && item.tradingSystemFee > 0 && (
            <TableRow key={`invoice-trading-fee-${index}`}>
              {!isMobile && (
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {t('new_invoice_table.trading_system_fee')}
                  </Typography>
                </TableCell>
              )}
              <TableCell colSpan={isMobile ? 2 : 3}></TableCell>
              <TableCell align="right">
                <Typography
                  variant="body2"
                  fontWeight={designTokens.typography.fontWeights.medium}
                >
                  <Statistic
                    prefix={CurrencyToSign[item.currency]}
                    value={item.tradingSystemFee * item.currencyRate}
                    precision={2}
                    align="right"
                  />
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default InvoiceTableBody;
